import { FC } from 'react';
import { PrimaryOutlinedButton } from '../../components';

/**
 *
 *
 *
 * @method Interface
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
type Props = {
  message: string;
  link: string;
};

/**
 *
 *
 *
 * @method Components
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
const NotificationCommit: FC<Props> = (props: Props) => {
  const { message, link } = props;

  return (
    <>
      <pre>{message}</pre>

      <div className="module-spacer--small" />
      <PrimaryOutlinedButton label="お知らせ一覧へ" linkTo={link} />
    </>
  );
};

export default NotificationCommit;
